<template>
    <div class="overflow-hidden relative w-full" :class="[fullScreen ? 'h-full' : `h-0 ${padding}`]">
        <!-- The video container (empty until the script is loaded and the player is initialized) -->
        <div :id="videoContainerId" class="object-cover object-center absolute top-0 left-0 w-full h-full"
             v-html="embedCode"></div>

        <!-- Optional content slot -->
        <slot v-if="firstPlay && fullScreen" />
    </div>
</template>

<script lang="ts">

export default {
    inject: ['$globalLabels'],
    props: {
        id: { type: String },
        embedCode: { type: String, required: true },
        rendition: { type: String, default: 'landscape' },
        fullScreen: { type: Boolean, default: false },
    },
    data() {
        return {
            videoContainerId: undefined,
            firstPlay: true,
        };
    },
    computed: {
        padding(): string {
            return this.rendition === 'landscape' ? 'pt-16/9' : 'pt-3/4';
        },
    },
    /***********************
     * Vue lifecycle
     ***********************/
    mounted() {
        this.videoContainerId = this.id === '' ? 'video-player-' + Math.random().toString(16).slice(2) : this.id;
    },
};
</script>
